// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_to-iobject.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_to-iobject.js
// module chunks = 168707334958949